import * as Sentry from '@sentry/browser';
import { SENTRY_SEVERITY_LEVELS } from 'utils/constants';

export const sendErrorToSentry = (
  error,
  metadata = {},
  level = SENTRY_SEVERITY_LEVELS.ERROR
) => {
  const errorToSend =
    error instanceof Error ? error : new Error(JSON.stringify(error));
  const contexts = metadata.contexts || {};
  const { user_email } = metadata;

  Sentry.withScope((scope) => {
    if (user_email) {
      const currentUser = scope.getUser() || {};
      Sentry.setUser({
        ...currentUser,
        email: user_email
      });
    }
    scope.setLevel(level);
    Object.entries(contexts).forEach(([key, value]) => {
      scope.setContext(key, value);
    });
    Sentry.captureException(errorToSend);
  });
};
